import React, { Component } from 'react';
import { Container, Row, Col, Button, Form, Pagination, DropdownButton, Dropdown, Modal, ButtonToolbar, Tooltip, OverlayTrigger, Image, Alert } from 'react-bootstrap';
import Backend from '../../../Backend';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import TableWalletInfoRow from './tableWalletRow';
import Connection from '../../../Calls';
import { Bounce } from 'react-activity';
import CopyClip from '../../../Images/copy-clip.png';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import WarningBlueIcon from '../../../Images/warningblue.svg'

import '../../../style-animations.css';
import './walletAddresses.css'

// var HeightScreen = window.screen.height;

class WalletAddressesCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newPassword: '',
      confirmPassword: '',
      displayCardSelected: 'list',
      search: '',
      numeroFilas: 10,
      paginaActual: 1,
      walletslistpagination: [],
      showload: false,
      amount: 1,
      alias: '',
      showModalAddress: false,
      extend: false,
      aliasValue: '',
      orderBySelect: props.traductions.General.filtros.Date_newest,
      sendOrderBySelect: 'date_new',
      ClipboardText:props.traductions.General.copyToClip,
      idTooltip:'',
      net: null,
      optionsNet: [],
      isToken: false
    }
    this.walletsPagination = this.walletsPagination.bind(this);
  }

  componentWillMount() {
    this.walletsPagination(this.state.paginaActual, this.state.numeroFilas, this.state.sendOrderBySelect);
    this.xrpAddress();
    this.getNetwork();
  }

  getNetwork(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.availableCoins_rt( localStorage.getItem('token'), response.payload.r01, localStorage.getItem('email'), response => {
        let filter_token;
        if (response.status.code === "0") {
          filter_token = response.payload.filter( item => item.type === 'token' && item.symbol === this.props.walletsinformation.coin);
          if (filter_token.length > 0){
            this.setState({optionsNet: filter_token[0].networks, isToken:true, net:filter_token[0].networks[0].net});
          }
        }
      })
    });
  }

  walletsPagination(value_paginaActual, value_numeroFilas, value_sortbyFilter) {
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");

    self.setState({ showload: true, paginaActual: value_paginaActual, numeroFilas: value_numeroFilas, sendOrderBySelect: value_sortbyFilter, walletslistpagination: [], });
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.WalletsPagination(localStorage.getItem('email'), localStorage.getItem('token'), idWallet, value_numeroFilas, value_paginaActual, response.payload.r01, this.state.search, value_sortbyFilter, response => {
        if (response.status.code === "0") {
          self.setState({
            walletslistpagination: response.payload.address_list,
            dataLength: Math.ceil(response.payload.total_amount / value_numeroFilas),
            showload: false
          });
        } else {
          self.setState({
            walletslistpagination: [],
            showload: false
          });
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      });
    });
  }

  handleCloseAddress() { this.setState({ showModalAddress: false }); }

  handleShowAddress() { this.setState({ showModalAddress: true }); }

  changePage(value) {
    this.setState({
      paginaActual: value,
    });
    this.walletsPagination(value, this.state.numeroFilas, this.state.sendOrderBySelect);
  }

  renderListWallets() {
    const self = this;
    var users = [];
    self.state.walletslistpagination.forEach(function (row) {
      users.push(
        <TableWalletInfoRow {...self.props} row={row} walletsinformation={self.props.walletsinformation} walletsPagination={self.walletsPagination} extend={self.state.extend} xrpAddress={self.state.xrpAddress}/>
      );
    });
    return users;
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.setState({ walletslistpagination: [] })
      this.walletsPagination(1, this.state.numeroFilas, this.state.sendOrderBySelect);
    }
  }

  AddAddresses() {
    const {walletsinformation} = this.props;
    let network;
    if ( walletsinformation && this.state.net){
      network = this.state.net;
    } else {
      network = null
    }

    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    var addresses_amount = self.addressesRestants();
    if (this.state.alias !== "" && this.state.amount !== "") {
      if (self.state.amount > 0) {
        if (self.state.amount <= (self.props.planInfo.addresses_per_coin - addresses_amount)) {
          let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
          navigator.geolocation.getCurrentPosition((success, error, options) => {
            latitude = success.coords.latitude;
            longitude = success.coords.longitude
          });
          result = latitude + longitude;
          Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.AddAddressInWallet(localStorage.getItem('email'), localStorage.getItem('token'), idWallet, this.state.alias, this.state.amount, network, response.payload.r01, response => {
              if (response.status.code === "0") {
                self.walletsPagination(1, 10);
                self.handleCloseAddress();
                self.setState({
                  alias: '',
                  amount: 1,
                });
                store.addNotification({
                  title: "Success!",
                  message: "Address has been added",
                  type: "success",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
              } else {
                store.addNotification({
                  title: "Error!",
                  message: response.status.description,
                  type: "danger",
                  insert: "top",
                  container: "top-right",
                  animationIn: ["animated", "fadeIn"],
                  animationOut: ["animated", "fadeOut"],
                  dismiss: {
                    duration: 1800,
                    onScreen: true
                  }
                });
              }
            });
          });
        } else {
          store.addNotification({
            title: "Error!",
            message: "The account has reached the max amount of addresses",
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
        }
      } else {
        store.addNotification({
          title: "Error!",
          message: "The quantity must be greater than 0",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true
          }
        });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify information, fields cannot be empty",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
    }
  }

  xrpAddress(){
    const self = this;
    var idWallet = new window.URL(window.location.href).searchParams.get("id");
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.XrpAddress( localStorage.getItem('token'), response.payload.r01, localStorage.getItem('email'), response => {
        this.setState({
          xrpAddress: response.payload.address
        })
      localStorage.setItem('xrpAddress', response.payload.address);
      })

    });

  }

  extender(value) {
    this.setState({
      extend: value
    });
    var test = document.getElementById('test');
    test.classList.toggle('extend')
  }

  addressesRestants() {
    const self = this;
    var result = 0;
    var symbolSelect = new window.URL(window.location.href).searchParams.get("coin");
    self.props.coinsInfo.forEach(function (row) {
      if (symbolSelect !== "") {
        if (row.coin === symbolSelect) {
          result = row.addresses;
        }
      }
    });
    return result;
  }

  CopyToClipboard(){
    const self=this
    self.setState({ClipboardText:self.props.traductions.General.copiedToClip, idTooltip:'tooltip-right fade-in'});
    setTimeout(function(){ self.setState({ idTooltip:' tooltip-right fade-out'}) }, 1000)
    setTimeout(function(){ self.setState({ClipboardText:self.props.traductions.General.copyToClip,idTooltip:''}) }, 2000)
  }

  handleOnchange (e){
    console.log("Changed Network: "+e.target.value)
    this.setState({net: e.target.value});
  }
  
  render() {
    const {optionsNet} = this.state;
    return (
      <div className="container-shadow-card-wallets-information">
        <div className="border-title-separator-container">
          <div
            className="border-title-separator-container-left"
            style={{ width: "100%" }}
          >
            {this.props.walletsinformation.coin == "xrp" ? (
              <p className="title-container-shadow">
                {this.props.traductions.wallets.overview.AddressesTitleXrp}:{" "}
                <span style={{ color: "black", fontSize: 15 }}>
                  {this.state.xrpAddress}
                </span>
                <OverlayTrigger
                  placement={"right"}
                  overlay={
                    <Tooltip className={this.state.idTooltip}>
                      {this.state.ClipboardText}
                    </Tooltip>
                  }
                >
                  <CopyToClipboard text={this.state.xrpAddress}>
                    <button
                      className="copy-tag-clipboard"
                      onClick={() => {
                        this.CopyToClipboard();
                      }}
                    >
                      <Image src={CopyClip} style={{ height: 15 }} />
                    </button>
                  </CopyToClipboard>
                </OverlayTrigger>
              </p>
            ) : (
              <p className="title-container-shadow">
                {this.props.traductions.wallets.overview.Addresses}
              </p>
            )}
          </div>
          <div className="border-title-separator-container-right">
            <p className="subtitle-container-shadow">
              {this.props.planInfo.name} plan: {this.addressesRestants()} /{" "}
              {this.props.planInfo.addresses_per_coin}
            </p>
          </div>
        </div>
        {/* style={{ height: HeightScreen - 445 }}  */}
        <div className="container-interno-addresses">
          <Row style={{ marginBottom: 20 }}>
            <Col md={4} className="virtual_exchange_dropdown">
              <Form.Label className="virtual_exchange_information_wallets_text">
                {this.props.traductions.wallets.overview.L_sort}:
              </Form.Label>
              <DropdownButton title={this.state.orderBySelect}>
                <Dropdown.Item
                  onClick={() => {
                    this.setState({
                      orderBySelect:
                        this.props.traductions.General.filtros.Date_newest,
                    });
                    this.walletsPagination(1, 10, "date_new");
                  }}
                  as="button"
                >
                  {this.props.traductions.General.filtros.Date_newest}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    this.setState({
                      orderBySelect:
                        this.props.traductions.General.filtros.Date_older,
                    });
                    this.walletsPagination(1, 10, "date_old");
                  }}
                  as="button"
                >
                  {this.props.traductions.General.filtros.Date_older}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    this.setState({
                      orderBySelect:
                        this.props.traductions.General.filtros.Deposits_lower,
                    });
                    this.walletsPagination(1, 10, "deposits_low");
                  }}
                  as="button"
                >
                  {this.props.traductions.General.filtros.Deposits_lower}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    this.setState({
                      orderBySelect:
                        this.props.traductions.General.filtros.Deposits_bigger,
                    });
                    this.walletsPagination(1, 10, "deposits_big");
                  }}
                  as="button"
                >
                  {this.props.traductions.General.filtros.Deposits_bigger}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    this.setState({
                      orderBySelect:
                        this.props.traductions.General.filtros.Label_ascendant,
                    });
                    this.walletsPagination(1, 10, "label_asc");
                  }}
                  as="button"
                >
                  {this.props.traductions.General.filtros.Label_ascendant}
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    this.setState({
                      orderBySelect:
                        this.props.traductions.General.filtros.Label_descendant,
                    });
                    this.walletsPagination(1, 10, "label_desc");
                  }}
                  as="button"
                >
                  {this.props.traductions.General.filtros.Label_descendant}
                </Dropdown.Item>
              </DropdownButton>
            </Col>
            <Col md={4} className="virtual_exchange_dropdown">
              <Form.Label className="virtual_exchange_information_wallets_text">
                {this.props.traductions.wallets.overview.L_search}:
              </Form.Label>
              <Form.Control
                style={{ height: 40 }}
                className="input-signup"
                type="text"
                placeholder={this.props.traductions.wallets.overview.L_search}
                value={this.state.search}
                onKeyPress={this.handleKeyPress}
                onChange={(search) => {
                  this.setState({ search: search.target.value });
                }}
              />
            </Col>
            <Col
              md={4}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              {this.props.walletsinformation.status !== "enabled" ? (
                <ButtonToolbar>
                  <OverlayTrigger
                    key="right"
                    placement="right"
                    show={true}
                    overlay={
                      <Tooltip id="tooltip-right">
                        {this.props.traductions.wallets.overview.L_wallet}{" "}
                        {this.props.walletsinformation.status}
                      </Tooltip>
                    }
                  >
                    {this.props.walletsinformation.coin == "xrp" ? (
                      <Button
                        style={{ cursor: "no-drop" }}
                        className="add-wallets-generals-button-blocked"
                      >
                        {this.props.traductions.wallets.overview.btn_AddTag}
                      </Button>
                    ) : (
                      <Button
                        style={{ cursor: "no-drop" }}
                        className="add-wallets-generals-button-blocked"
                      >
                        {this.props.traductions.wallets.overview.btn_Add}
                      </Button>
                    )}
                  </OverlayTrigger>
                </ButtonToolbar>
              ) : (
                <Button
                  onClick={() => {
                    this.handleShowAddress();
                  }}
                  className="add-wallets-generals-button"
                >
                  {this.props.walletsinformation.coin == "xrp"
                    ? this.props.traductions.wallets.overview.btn_AddTag
                    : this.props.traductions.wallets.overview.btn_Add}
                </Button>
              )}
            </Col>
          </Row>
          {this.props?.walletsinformation?.coin === "bch" && (
            <div className="warning-announce">
              <div className="icon-warning-announce">
                <Image src={WarningBlueIcon} />
              </div>
              <div>
                <p className="text-warning-announce">
                  {this.props.traductions.wallets.overview.warning_bch}
                </p>
              </div>
            </div>
          )}
          <div
            className="scroll-table-wallets-generals"
            style={{ height: "calc(100vh - 375px)" }}
          >
            <table className="table-container-wallets-generals">
              <thead>
                <tr>
                  <th className="header-table-wallets-generals fixxxed"></th>
                  {this.props.walletsinformation.coin == "xrp" ? (
                    <th className="header-table-wallets-generals fixxxed">
                      {this.props.traductions.wallets.overview.T_h_TAG}
                    </th>
                  ) : (
                    <th className="header-table-wallets-generals fixxxed">
                      {this.props.traductions.wallets.overview.T_h_ADDRESS}
                    </th>
                  )}
                  <th className="header-table-wallets-generals fixxxed"></th>
                  <th className="header-table-wallets-generals fixxxed">
                    {this.props.traductions.wallets.overview.T_h_LABEL}
                  </th>
                  <th className="header-table-wallets-generals fixxxed align-text-right">
                    {this.props.traductions.wallets.overview.T_h_deposits}
                  </th>
                  <th className="header-table-wallets-generals fixxxed align-text-right">
                    {this.props.traductions.wallets.overview.T_h_date}
                  </th>
                  <th className="header-table-wallets-generals fixxxed align-text-center">
                    qr
                  </th>
                </tr>
              </thead>
              <tbody>{this.renderListWallets()}</tbody>
            </table>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 20,
            }}
          >
            <DropdownButton
              id="dropdown-item-button-step1"
              title={this.state.numeroFilas}
            >
              <Dropdown.Item
                onClick={() => {
                  this.setState({ numeroFilas: 10 });
                  this.walletsPagination(1, 10, "date_new");
                }}
                as="button"
              >
                10
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  this.setState({ numeroFilas: 25 });
                  this.walletsPagination(1, 25, "date_new");
                }}
                as="button"
              >
                25
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  this.setState({ numeroFilas: 50 });
                  this.walletsPagination(1, 50, "date_new");
                }}
                as="button"
              >
                50
              </Dropdown.Item>
            </DropdownButton>

            <Pagination>
              <Pagination.First
                disabled={this.state.paginaActual === 1 || this.state.spinner}
                onClick={() => {
                  if (this.state.paginaActual !== 0) {
                    this.changePage(1);
                  }
                }}
              />
              <Pagination.Prev
                disabled={this.state.paginaActual === 1 || this.state.spinner}
                onClick={() => {
                  if (this.state.paginaActual !== 0) {
                    this.changePage(this.state.paginaActual - 1);
                  }
                }}
              />
              {this.state.paginaActual > 2 && (
                <Pagination.Item
                  disabled={this.state.spinner}
                  onClick={() => {
                    this.changePage(this.state.paginaActual - 2);
                  }}
                >
                  {this.state.paginaActual - 2}
                </Pagination.Item>
              )}
              {this.state.paginaActual > 1 && (
                <Pagination.Item
                  disabled={this.state.spinner}
                  onClick={() => {
                    this.changePage(this.state.paginaActual - 1);
                  }}
                >
                  {this.state.paginaActual - 1}
                </Pagination.Item>
              )}
              <Pagination.Item active>
                {this.state.paginaActual}
              </Pagination.Item>
              {this.state.paginaActual < this.state.dataLength && (
                <Pagination.Item
                  disabled={this.state.spinner}
                  onClick={() => {
                    this.changePage(this.state.paginaActual + 1);
                  }}
                >
                  {this.state.paginaActual + 1}
                </Pagination.Item>
              )}
              {this.state.paginaActual < this.state.dataLength - 1 && (
                <Pagination.Item
                  disabled={this.state.spinner}
                  onClick={() => {
                    this.changePage(this.state.paginaActual + 2);
                  }}
                >
                  {this.state.paginaActual + 2}
                </Pagination.Item>
              )}
              <Pagination.Next
                disabled={
                  this.state.paginaActual >= this.state.dataLength ||
                  this.state.spinner
                }
                onClick={() => {
                  if (this.state.paginaActual < this.state.dataLength) {
                    this.changePage(this.state.paginaActual + 1);
                  }
                }}
              />
              <Pagination.Last
                disabled={
                  this.state.paginaActual >= this.state.dataLength ||
                  this.state.spinner
                }
                onClick={() => {
                  if (this.state.paginaActual < this.state.dataLength) {
                    this.changePage(this.state.dataLength);
                  }
                }}
              />
            </Pagination>
          </div>
        </div>

        {this.props.walletsinformation.coin == "xrp" ? (
          <Modal
            className="modal-signup-resend-email"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            show={this.state.showModalAddress}
            onHide={() => {
              this.handleCloseAddress();
            }}
          >
            <Modal.Body>
              <div className="border-title-separator-container">
                <div className="border-title-separator-container-left">
                  <p className="title-container-shadow">New tag</p>
                </div>
                <div className="border-title-separator-container-right">
                  <p className="subtitle-container-shadow">Add your tag</p>
                </div>
              </div>

              <div className="steps-add-wallet-general">
                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    Alias:
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      className="input-signup"
                      type="text"
                      placeholder="Name of Alias"
                      value={this.state.alias}
                      onChange={(alias) => {
                        this.setState({ alias: alias.target.value });
                      }}
                    />
                  </Col>
                </Form.Group>
                {/* <Form.Group as={Row}>
                <Form.Label column sm="2" className="label-modal">Amount:</Form.Label>
                <Col sm="10">
                  <Form.Control className="input-signup" type="number" min="1" placeholder="Amount of addresses" value={this.state.amount} onChange={(amount) => { this.setState({ amount: amount.target.value }) }} />
                </Col>
              </Form.Group> */}
              </div>

              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button
                  onClick={() => {
                    this.AddAddresses();
                  }}
                  className="signup-button"
                  variant="primary"
                  disabled={this.state.showLoad}
                >
                  {this.state.showload ? (
                    <Bounce
                      size={20}
                      color={"#FFFFFF"}
                      animating={this.state.showload}
                    />
                  ) : (
                    "Create tag"
                  )}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        ) : (
          <Modal
            className="modal-signup-resend-email"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            show={this.state.showModalAddress}
            onHide={() => {
              this.handleCloseAddress();
            }}
          >
            <Modal.Body>
              <div className="border-title-separator-container">
                <div className="border-title-separator-container-left">
                  <p className="title-container-shadow">New Address</p>
                </div>
              </div>

              <div className="steps-add-wallet-general">
                {this.state.isToken && (
                  <Form.Group as={Row}>
                    <Form.Label column sm="2" className="label-modal">
                      Red:
                    </Form.Label>
                    <Col sm="10">
                      <Form.Control
                        onChange={(e) => this.handleOnchange(e)}
                        as="select"
                        aria-label="Default select example"
                      >
                        {optionsNet &&
                          optionsNet.length > 0 &&
                          optionsNet.map((option, index) => (
                            <option key={index} value={option.net}>
                              {option.name}
                            </option>
                          ))}
                      </Form.Control>
                    </Col>
                  </Form.Group>
                )}

                <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">
                    Alias:
                  </Form.Label>
                  <Col sm="10">
                    <Form.Control
                      className="input-signup"
                      type="text"
                      placeholder="Name of Alias"
                      value={this.state.alias}
                      onChange={(alias) => {
                        this.setState({ alias: alias.target.value });
                      }}
                    />
                  </Col>
                </Form.Group>
                {/* {
                  (this.props.walletsinformation.coin == 'usdt')&&

                      <Alert variant='warning' style={{marginBottom:10, marginTop:10, textAlign:'center'}}>
                        Address will be created in the Solana network
                      </Alert>

                } */}
                {/* <Form.Group as={Row}>
                  <Form.Label column sm="2" className="label-modal">Amount:</Form.Label>
                  <Col sm="10">
                    <Form.Control className="input-signup" type="number" min="1" placeholder="Amount of addresses" value={this.state.amount} onChange={(amount) => { this.setState({ amount: amount.target.value }) }} />
                  </Col>
                </Form.Group> */}
              </div>

              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button
                  onClick={() => {
                    this.AddAddresses();
                  }}
                  className="signup-button"
                  variant="primary"
                  disabled={this.state.showLoad}
                >
                  {this.state.showload ? (
                    <Bounce
                      size={20}
                      color={"#FFFFFF"}
                      animating={this.state.showload}
                    />
                  ) : (
                    "Create address"
                  )}
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
} export default WalletAddressesCard;
